export function getCurrentWeekStartDate(): string {
  const today = new Date();
  const day = today.getDay();
  const diff = (day + 6) % 7;
  const monday = new Date(today);
  monday.setDate(today.getDate() - diff);
  monday.setHours(0, 0, 0, 0);
  return monday.toISOString().split('T')[0];
}
